export default __webpack_public_path__ + "static/media/QueenAnnesLace.62b055a5.jpg";